import React from 'react';

export interface ToggleButtonGroupProps {
  value: string;
  onChange: (value: string) => void;
  children: React.ReactNode;
  className?: string;
}

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({
  value,
  onChange,
  children,
  className = ''
}) => {
  return (
    <div className={`inline-flex rounded-lg border border-gray-300 ${className}`}>
      {React.Children.map(children, (child) => {
        if (React.isValidElement<ToggleButtonProps>(child)) {
          return React.cloneElement(child, {
            active: value === child.props.value,
            onClick: () => onChange(child.props.value),
          });
        }
        return child;
      })}
    </div>
  );
};

export interface ToggleButtonProps {
  value: string;
  children: React.ReactNode;
  active?: boolean;
  onClick?: () => void;
  'aria-label'?: string;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  children,
  active = false,
  onClick,
  'aria-label': ariaLabel,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={`px-4 py-2 text-sm font-medium transition-colors first:rounded-l-lg last:rounded-r-lg ${
        active
          ? 'bg-primary-600 text-white'
          : 'bg-white text-gray-700 hover:bg-gray-50'
      }`}
    >
      {children}
    </button>
  );
};
